import(/* webpackMode: "eager", webpackExports: ["ResetPasswordForm"] */ "/app/app/src/features/auth/reset-password/ui/ResestPasswordForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
